import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f1f731a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "crowdloan-item" }
const _hoisted_2 = { class: "crowdloan-item__block" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "crowdloan-item__info-block" }
const _hoisted_6 = { class: "crowdloan-item__block" }
const _hoisted_7 = { class: "crowdloan-item__block-info" }
const _hoisted_8 = { class: "crowdloan-item__block-info-amount" }
const _hoisted_9 = {
  key: 0,
  class: "crowdloan-item__block-info-count"
}
const _hoisted_10 = { class: "crowdloan-item__block" }
const _hoisted_11 = { class: "crowdloan-item__block" }
const _hoisted_12 = {
  key: 0,
  class: "crowdloan-item__block-action"
}
const _hoisted_13 = { class: "crowdloan-item__block-action-timer" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 1 }

import { computed, onMounted, PropType, ref, toRef, watch } from "vue";
import { ContributionInfo, CrowdloanInfo } from "@/types/crowdloan";
import BaseButton from "@/components/base-button/index.vue";
import LinkIcon from "@/icons/common/link-icon.vue";
import { useRouter } from "vue-router";
import {
  accounts,
  apiPromise,
  nativeToken,
  selectedCrowdloan,
  selectedNetwork,
} from "@/stores";
import { getContributions } from "@/utils/crowdloan";
import VueCountdown from "@chenfengyuan/vue-countdown";
import { cryptoCurrencyFormat } from "@/utils/filters";


export default /*#__PURE__*/_defineComponent({
  __name: 'crowdloan-item',
  props: {
  item: {
    type: Object as PropType<CrowdloanInfo>,
    default: null,
  },
  address: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props;

const router = useRouter();

const contribution = ref<ContributionInfo>({
  blockHash: "-",
  contributorsHex: [],
  hasLoaded: false,
  account: "",
  accountHex: "",
  amount: 0,
});



const address = toRef(props, "address");
const isHover = ref(false);

onMounted(() => {
  loadContributionData();
});

watch(
  [selectedNetwork, accounts, address],
  () => {
    loadContributionData();
  },
  { deep: true }
);

const loadContributionData = async () => {
  if (props.address) {
    const api = await apiPromise.value;
    contribution.value.hasLoaded = false;
    contribution.value = await getContributions(
      api,
      props.item.paraId,
      props.address
    );
  }
};

const contributedLabel = computed(() => {
  return `${cryptoCurrencyFormat(
    contribution.value.amount
  )} ${nativeToken.value.symbol.toLocaleUpperCase()}`;
});

const contributeAction = () => {
  selectedCrowdloan.value = props.item;
  router.push({
    name: "crowdloan-contribute",
    query: { address: props.address },
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        class: "crowdloan-item__info",
        href: __props.item.link,
        target: "_blank"
      }, [
        _createElementVNode("img", {
          src: __props.item.image,
          alt: ""
        }, null, 8, _hoisted_4),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h3", null, _toDisplayString(__props.item.name), 1),
          _createVNode(LinkIcon, { class: "crowdloan-item__info-block-link" })
        ])
      ], 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("p", _hoisted_8, [
          _createElementVNode("b", null, _toDisplayString(__props.item.percent.toFixed(2)) + " %", 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$filters.formatCompactNumber(__props.item.amount)) + " of " + _toDisplayString(_ctx.$filters.formatCompactNumber(__props.item.cap)), 1)
        ]),
        (contribution.value.contributorsHex.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.$filters.cryptoCurrencyFormat(contribution.value.contributorsHex.length)) + " contributions ", 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("span", null, _toDisplayString(__props.item.tokens), 1)
    ]),
    _createElementVNode("div", _hoisted_11, [
      (__props.item.isContribute)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("p", _hoisted_13, [
              _createTextVNode(" Ending in"),
              _createElementVNode("b", null, [
                _createVNode(_unref(VueCountdown), {
                  interval: 60000,
                  time: __props.item.endMillisecondsLeft
                }, {
                  default: _withCtx(({ days, hours, minutes }) => [
                    _createTextVNode(_toDisplayString(`${days ? ` ${days}d` : ""}${
                  hours ? ` ${hours}h` : ""
                } ${minutes}m`), 1)
                  ]),
                  _: 1
                }, 8, ["time"])
              ])
            ]),
            (contribution.value.amount)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(BaseButton, {
                    class: "crowdloan-item__block-action-contribute-button",
                    title: isHover.value ? 'Contribute' : contributedLabel.value,
                    small: true,
                    action: contributeAction,
                    onMouseover: _cache[0] || (_cache[0] = ($event: any) => (isHover.value = true)),
                    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (isHover.value = false))
                  }, null, 8, ["title"])
                ]))
              : (_openBlock(), _createBlock(BaseButton, {
                  key: 1,
                  title: "Contribute",
                  small: true,
                  action: contributeAction
                }))
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_15, [
            (contribution.value.hasLoaded)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  (contribution.value.amount)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createVNode(BaseButton, {
                          class: "crowdloan-item__block-action-existing-contribution",
                          title: contributedLabel.value,
                          small: true,
                          action: contributeAction
                        }, null, 8, ["title"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_18, "-"))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_19, "Loading contribution..."))
          ]))
    ])
  ]))
}
}

})